import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";

import ForkOutlined from "@ant-design/icons/ForkOutlined";

import ApplyWarning from "./ConflictingWarningTooltip";

const ObjectSelectionArea = ({ objects, applyAll, handleCheckboxCheck, objectType }) => {
  return (objects?.length !== 0 && (<div style={{ maxHeight: "200px", overflowY: "auto", marginTop: "10px", background: "#f0f0f0" }}>
    <Grid container columnSpacing={4} rowSpacing={1} sx={{ padding: "10px" }}>
      {objects.map(({ id, displayName, conflicted, IsDeleted, checked }) => (
        <Grid
          key={id}
          style={{ paddingTop: 0, display: "flex", alignItems: "center" }}
          size={{
            xs: 12,
            sm: 6,
            md: 4
          }}>
          <Tooltip
            placement="bottom"
            title={
              IsDeleted == 1 ? (
                <Box sx={{ fontSize: "0.875rem" }}>
                  {objectType == "sources" ? "This Dataset has been deleted" : "This Entity has been deleted"}
                </Box>
              ) : (
                ""
              )
            }
            arrow
          >
            <FormControlLabel
              label={
                <>
                  <span style={{ verticalAlign: "middle" }}>
                    {displayName} {IsDeleted == 1 ? " (Deleted)" : ""}
                  </span>
                  {conflicted &&
                    Object.keys(conflicted).length > 0 &&
                    (conflicted?.sources?.length > 0 || conflicted?.entities?.length > 0) && (
                      <Tooltip
                        placement="top"
                        disableHoverListener={applyAll}
                        title={
                          <ApplyWarning
                            sources={conflicted.sources}
                            entities={conflicted.entities}
                            objectType={objectType}
                          />
                        }
                        arrow
                      >
                        <ForkOutlined style={{ verticalAlign: "middle", marginLeft: "4px", color: "#0288d1" }} />
                      </Tooltip>
                    )}
                </>
              }
              sx={{ userSelect: "none", margin: "none", wordBreak: "break-all", marginRight: "10px" }}
              control={<Checkbox checked={checked} onChange={(e) => handleCheckboxCheck(e, objectType)} />}
              disabled={applyAll || IsDeleted === 1}
              value={id}
            />
          </Tooltip>
        </Grid>
      ))}
    </Grid>
  </div>));
};

ObjectSelectionArea.propTypes = {
  objects: PropTypes.array.isRequired,
  applyAll: PropTypes.bool.isRequired,
  handleCheckboxCheck: PropTypes.func.isRequired,
  objectType: PropTypes.string.isRequired,
};

export default React.memo(ObjectSelectionArea);
